import React, { Component } from "react";

class LocationSearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = { value: "", errorText: "", submitBtnDisabled: false };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    let formMsg = this.props.formMsg;
    if (formMsg.length > 0) {
      this.setState({ errorText: formMsg });
    }
  }

  handleChange(event) {
    this.setState({ value: event.target.value, errorText: "" });
    if (event.target.value.length > 0) {
      //enable button
    } else {
      //disablebutton
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    //alert("A name was submitted: " + this.state.value);
    if (this.state.value == " " || this.state.value == "") {
      this.setState({ errorText: "Please enter a valid Location" });
      //this.props.formResponse
    } else {
      this.props.checkCityTest(this.state.value);
      this.setState({ value: "" });
    }
  }
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <input
          type="text"
          id="search-input"
          value={this.state.value}
          onChange={this.handleChange}
        />

        <input
          type="submit"
          className="btn"
          value="Search"
          disabled={this.state.submitBtnDisabled}
        />
        <div className="form-error">{this.state.errorText}</div>
      </form>
    );
  }
}

export default LocationSearchForm;
